<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive }
    ]"
  >

    <Search name="siteSearch"></Search>

    <SidePanel v-if="!notfound" />

    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <!--
      User Menu is a little buggy so just gonna stuff some links in the main nav for now.
      <user-menu></user-menu>
      -->
      <mobile-menu></mobile-menu>
      <template slot="links">

        <!-- Quick link -->
        <sidebar-item :link="{ name: 'Quick Links', icon: 'link', collapsed: false }" v-if="$route ? $route.meta.quickLinks ? $route.meta.quickLinks.showQuickLinks : false : false" >
          <sidebar-item :forceLink="true"
            :link="{ name: '', path: '#temp', isQuickLink: true, id: '' }"
            ></sidebar-item>
          <template v-for="(link, key) in $route.meta.quickLinks.links">
            <a :key="key" class="nav-link quick-link-color" 
              @click.prevent="navigateToQuickLink(link.id)" href="#">
              
               <template>
                  <span class="sidebar-mini">{{linkPrefix(link.label)}}</span>
                  <span class="sidebar-normal">{{ link.label }}</span>
                </template>
              </a>
          </template>
        </sidebar-item>

        <sidebar-item
          :link="{ name: 'Dashboard', icon: 'dashboard', path: '/dashboard' }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{ name: 'Cases', icon: 'how_to_vote', path: '/cases' }"
        ></sidebar-item>

        <sidebar-item
          :link="{ name: 'Tasks', icon: 'assignment', path: '/tasks' }"
        >
        </sidebar-item>

        <!-- <sidebar-item
          :link="{ name: 'Messages', icon: 'email', path: '/messages' }"
        ></sidebar-item> -->

        <sidebar-item
          :link="{ name: 'Services', icon: 'style', path: '/services' }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{ name: 'Accounts', icon: 'work', path: '/accounts' }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{ name: 'Products', icon: 'devices', path: '/products' }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{ name: 'People', icon: 'people_alt', path: '/people' }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{ name: 'Companies', icon: 'store', path: '/companies' }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{ name: 'Portfolios', icon: 'folder', path: '/portfolios' }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{ name: 'Sales Reps', icon: 'assignment_ind', path: '/salesreps' }"
        >
        </sidebar-item>

        <sidebar-item :link="{ name: 'Reporting', icon: 'folder' }" v-if="isAdminGroupMember">
          <sidebar-item :forceLink="true"
            :link="{ name: 'Bonuses', icon: 'list_alt', path: '/reports/bonus' }"
          ></sidebar-item>

          <sidebar-item :forceLink="true"
            :link="{ name: 'Conversion Bonuses', icon: 'ballot', path: '/reports/conversion-bonus' }"
          >
          </sidebar-item>

          <sidebar-item :forceLink="true"
            :link="{ name: 'Clawback: Closed/Never Live vs Approval Date', icon: 'devices', path: '/reports/clawback-closed-never-live-vs-approval-date' }"
          >
          </sidebar-item>

          <sidebar-item :forceLink="true"
            :link="{ name: 'Clawback: Rates Lowered', icon: 'emoji_people', path: '/reports/clawback-rates-lowered' }"
          >
          </sidebar-item>
          <sidebar-item :forceLink="true"
            :link="{ name: 'BETA Services', icon: 'group', path: '/reports/beta-services' }"
          >
          </sidebar-item>          
        </sidebar-item>





        <sidebar-item :link="{ name: 'Admin', icon: 'settings' }" v-if="isAdminGroupMember">

          <sidebar-item :forceLink="true"
            :link="{ name: 'Case Templates', icon: 'list_alt', path: '/casetemplates' }"
          ></sidebar-item>

          <sidebar-item :forceLink="true"
            :link="{ name: 'Task Templates', icon: 'ballot', path: '/tasktemplates' }"
          >
          </sidebar-item>

          <sidebar-item :forceLink="true"
            :link="{ name: 'Product Options', icon: 'devices', path: '/productoptions' }"
          >
          </sidebar-item>

          <sidebar-item :forceLink="true"
            :link="{ name: 'Users', icon: 'emoji_people', path: '/users' }"
          >
          </sidebar-item>
          <sidebar-item :forceLink="true"
            :link="{ name: 'Teams', icon: 'group', path: '/teams' }"
          >
          </sidebar-item>
          <sidebar-item :forceLink="true"
            :link="{ name:'HQ', icon: 'business', path: '/hq' }"
          >
          </sidebar-item>
          <sidebar-item :forceLink="true"
            :link="{ name:'Sales Offices', icon: 'business', path: '/salesoffice' }"
          >
          </sidebar-item>

        </sidebar-item>


<!--
        <sidebar-item :link="{ name: 'Examples', icon: 'apps' }" v-if="true">
          <sidebar-item :link="{ name: 'Pages', icon: 'image' }">
            <sidebar-item
              :link="{ name: 'Pricing', path: '/pricing' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Timeline', path: '/pages/timeline' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Login', path: '/login' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Register', path: '/register' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Lock Screen', path: '/lock' }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item :link="{ name: 'Components', icon: 'apps' }">
            <sidebar-item
              :link="{ name: 'Buttons', path: '/components/buttons' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Grid System', path: '/components/grid-system' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Panels', path: '/components/panels' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Sweet Alert', path: '/components/sweet-alert' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Notifications', path: '/components/notifications' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Icons', path: '/components/icons' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Typography', path: '/components/typography' }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item :link="{ name: 'Forms', icon: 'content_paste' }">
            <sidebar-item
              :link="{ name: 'Regular Forms', path: '/forms/regular' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Extended Forms', path: '/forms/extended' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Validation Forms', path: '/forms/validation' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Wizard', path: '/forms/wizard' }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item :link="{ name: 'Tables', icon: 'grid_on' }">
            <sidebar-item
              :link="{ name: 'Regular Tables', path: '/table-list/regular' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Extended Tables', path: '/table-list/extended' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Paginated Tables', path: '/table-list/paginated' }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item :link="{ name: 'Maps', icon: 'place' }">
            <sidebar-item
              :link="{ name: 'Google Maps', path: '/maps/google' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Full Screen Maps', path: '/maps/full-screen' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Vector Maps', path: '/maps/vector-map' }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item
            :link="{ name: 'Widgets', icon: 'widgets', path: '/widgets' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Charts', icon: 'timeline', path: '/charts' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Calendar', icon: 'date_range', path: '/calendar' }"
          ></sidebar-item>
        </sidebar-item>
        -->

      </template>
    </side-bar>
    <div class="main-panel">
      <div style="position:relative;"><!-- need this in order to size and position of the area within -->
        <top-navbar v-if="!notfound" :notfound="notfound">
          <div class="md-toolbar-row">
            <BreadCrumb v-if="!notfound"></BreadCrumb>
          </div>
          <div id="topPageToolbar" class="md-toolbar-row topNavTabs">

          </div>

        </top-navbar>
        <div id="mainPanelWindow">
        <!-- <BreadCrumb v-if="!notfound"></BreadCrumb> -->

        <fixed-plugin
          :color.sync="sidebarBackground"
          :colorBg.sync="sidebarBackgroundColor"
          :sidebarMini.sync="sidebarMini"
          :sidebarImg.sync="sidebarImg"
          :image.sync="sidebarBackgroundImage"
        >
        </fixed-plugin>

        <!-- if record no longer exist -->
        <div v-if="notfound" class="invalid-msg">
          <p>Record Doesn't Exist</p>
          <p>Please Verify the link that you are trying to Access!!</p>
        </div>
        <div
          :class="{ content: !$route.meta.hideContent }"
          @click="toggleSidebar"
        >
          <zoom-center-transition :duration="200" mode="out-in">
            <!-- your content here -->
            <router-view v-if="!notfound"></router-view>
          </zoom-center-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter && !notfound"></content-footer>
        </div>
      </div>
    </div>
    <div>
      <md-dialog-confirm
        class="inactivityAlertDialog"
        :md-active.sync="active"
        md-title="For security purposes, you are about to be logged out of the application.  Are you still working?"
        :md-content="`You will sign out in ${Math.floor(timerCount)} Seconds`"
        md-confirm-text="Yes"
        md-cancel-text="No"
        @md-cancel="onCancel"
        @md-confirm="onConfirm" />
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import Search from "@/components/Search";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "@/pages/Layout/Extra/MobileMenu.vue";
import FixedPlugin from "@/pages/Layout/FixedPlugin.vue";
import UserMenu from "@/pages/Layout/Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import BreadCrumb  from "@/components/BreadCrumb";
import SidePanel from '@/components/Sidebar/Sidebar';

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    FixedPlugin,
    UserMenu,
    ZoomCenterTransition,
    Search,
    BreadCrumb,
    SidePanel
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: (this.sidebarImg) ? "./img/sidebar-2.jpg" : "", // Instead removing image, check sidebarImg boolean value
      sidebarMini: true,
      sidebarImg: false,
      timeout: null,
      active: false,
      value: null,
      timerCount: 0,
      notfound: false,
    };
  },
  computed: {
    isAdminGroupMember() {
      return this.$Session && this.$Session.isAdminGroupMember;
    }
  },
  methods: {
    onDragOver() {
      document.body.classList.add('is-drag-active');
    },
    onDragDrop() {
      document.body.classList.remove('is-drag-active');
    },
    initDragAndDrop() {
      document.body.addEventListener('dragover', this.onDragOver);
      document.body.addEventListener('drop', this.onDragDrop);
      document.body.addEventListener('click', this.onDragDrop);
    },
    onConfirm () {
      this.active = false;
      this.timerCount = 0;
      this.refresh();
    },
    onCancel () {
      this.logginOff();
    },
    logginOff() {
      this.$Amplify.Auth.signOut();
      this.$set(this.$Session, 'userId', '');
      this.$set(this.$Session, 'alerts', []);
      this.$set(this.$Session, 'groups', []);
      this.$set(this.$Session, 'isInternalGroupMember', false);
      this.$set(this.$Session, 'isAdminGroupMember', false);
      this.$router.push("/login");
    },
    refresh(){
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        //Log out the user
        console.log('Inactivity User - Countdown for logging off');
        let timerInterval
        this.active = true;
        this.timerCount = 2 * 60;
      }, 58 * 60 * 1000)
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    navigateToQuickLink(hash) {
      if(hash) {
        let element = document.getElementById(hash);
        if(element) {
          // element.scrollIntoView({
          //   block: 'center',
          //   behavior: 'smooth'
          // });
          let parentOffsetTop = element.parentElement.parentElement.offsetTop;

          // window.scrollTo({
          //   top: parentOffsetTop + 75,
          //   left: 0,
          //   behavior: 'smooth'
          // });

          //ATLAS-1725
          element.scrollIntoView(true)

          //ATLAS-1778
          window.dispatchEvent(new Event('resize'));  
        }
      }
    },
    linkPrefix(name) {
      if (name) {
        let words = name.split(" ");
        return words.map(word => word.substring(0, 1)).join("");
      }
      return "";
    },
  },
  mounted() {
    this.initDragAndDrop();
    this.refresh();
    window.addEventListener('click', this.refresh);
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");
      // initScrollbar("main-panel");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
    window.$bus.$on("page-not-found", () => {
      this.notfound = true;
    });
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
    timerCount: {
        handler(value) {
            if (value > 0) {
                setTimeout(() => {
                    this.timerCount--;
                }, 1000);
            }
            if (this.timerCount == 1) {
              console.log('Inactivity User - Logging off')
              this.logginOff();
            }
        },
        immediate: true
    },
    "$route.params.id": {
      handler() {
        this.notfound = false;
      },
    },
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.invalid-msg {
  height: 11vh;
  margin: 20px;
  color: red;
  font-size: 20px;
  line-height: 16px;
  font-weight: 500;
}
.md-dialog.inactivityAlertDialog.md-theme-default {
  position: fixed;
  z-index: 30000 !important;
}
</style>
